__turbopack_context__.v({
  "addressText": "OutletCardOutletInfoSummary-module-scss-module__DiDGUq__addressText",
  "available": "OutletCardOutletInfoSummary-module-scss-module__DiDGUq__available",
  "container": "OutletCardOutletInfoSummary-module-scss-module__DiDGUq__container",
  "cuisineText": "OutletCardOutletInfoSummary-module-scss-module__DiDGUq__cuisineText",
  "footer": "OutletCardOutletInfoSummary-module-scss-module__DiDGUq__footer",
  "footerLeft": "OutletCardOutletInfoSummary-module-scss-module__DiDGUq__footerLeft",
  "orderFormat": "OutletCardOutletInfoSummary-module-scss-module__DiDGUq__orderFormat",
  "whiteLabeled": "OutletCardOutletInfoSummary-module-scss-module__DiDGUq__whiteLabeled",
});
